import app from 'flarum/common/app';
import MobileTabComponent from '../../common/components/MobileTabComponent';
import MobileTabItem from './MobileTabItem';
export default class ForumNotificationsTabItem extends MobileTabComponent {
  view() {
    if (!app.session.user) return;
    const unread = app.session.user.unreadNotificationCount();
    const {
      icon,
      label
    } = this.attrs.definition;
    return m(MobileTabItem, {
      href: app.route('notifications'),
      icon: icon
    }, unread ? m("span", {
      className: "Bubble"
    }, unread) : '', label);
  }
}
flarum.reg.add('gitzaai-v2mobileui', 'forum/components/ForumNotificationsTabItem', ForumNotificationsTabItem);